<!-- https://8es9hr.axshare.com/#g=1&p=%E6%97%A5%E7%B5%90%E4%BD%9C%E6%A5%AD_%E5%87%BA%E7%B4%8D-->
<!-- 日結作業_出納 -->
<template>
    <div style="display: flex">
        <Step :workflow="workflow"></Step>
        <div class="bgf step-form">
            <div class="col-block">
                <div class="block-header has-border">
                    <h3>
                        <strong>{{ $transferDate(settleDate) }} 結帳作業</strong>
                    </h3>
                </div>
                <!-- 出納 -->
                <div class="block-content">
                    今日開立收款單數量 :
                    {{ recordToEdit.voucherStatistic.cashVoucherCount }}
                    <router-link
                        class="ml10"
                        :to="{ name: 'coop_receipt', query: { settleDate: settleDate } }"
                        target="_blank"
                    >
                        <el-button type="primary" plain>收款單管理</el-button>
                    </router-link>
                    <br />
                    <table
                        class="table table-bordered mt10"
                        v-for="(item, key, idx) in recordToEdit.creatorList"
                    >
                        <tbody>
                            <tr>
                                <td colspan=" 2">
                                    專職人員 {{ idx + 1 }} {{ item.name }}
                                    {{ item.status ? "已處理" : "未處理" }}
                                    <br />收款金額
                                </td>
                            </tr>
                            <tr>
                                <td>小計 :</td>
                                <td>{{ $addcomma(item.statistic.incomingCashTotal) }} 元</td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    當日收款現金總額 :
                    {{ $addcomma(recordToEdit.voucherStatistic.incomingCashTotal) }}
                    <div class="line"></div>
                    支出轉帳傳票數量 :
                    {{ recordToEdit.voucherStatistic.transferVoucherCount }}
                    <router-link
                        class="ml10"
                        :to="{ name: 'expense_summons', query: { settleDate: settleDate } }"
                        target="_blank"
                    >
                        <el-button type="primary" plain>支出轉帳傳票管理</el-button>
                    </router-link>
                    <el-card
                        class="box-card mb10"
                        v-for="(item, idx) in recordToEdit.bankList"
                        :key="idx"
                    >
                        <p class="sub_title">{{ item.bankName }}</p>
                        <!-- <el-button type="primary" class="ml10" plain>查看交易明細</el-button> -->
                        <p class="sub_title">活存</p>
                        轉出 / 提款 :
                        {{
                        recordToEdit.bankStatistic[item.ddAccountTitleId] &&
                        $addcomma(recordToEdit.bankStatistic[item.ddAccountTitleId].out)
                        }}
                        <br />
                        匯入 / 存款 :
                        {{
                        recordToEdit.bankStatistic[item.ddAccountTitleId] &&
                        $addcomma(recordToEdit.bankStatistic[item.ddAccountTitleId].in)
                        }}
                    </el-card>
                    <div class="line"></div>
                    <p class="sub_title">出納作業</p>
                    <p>
                        <span class="require">*</span>庫存現金餘額
                        <el-input
                            v-model="recordToEdit.cashOnHand"
                            v-on:input="resetInput(recordToEdit.cashOnHand, 'cashOnHand')"
                        ></el-input>
                    </p>
                    <div v-for="(item, idx) in recordToEdit.bankList">
                        <p v-if="item.ddAccountTitleId">
                            <span class="require">*</span>
                            {{ item.bankName }} 活存餘額
                            <el-input
                                v-model="item.ddAccountBalance"
                                v-on:input="resetBankInput(item.ddAccountBalance, idx)"
                            ></el-input>
                        </p>
                    </div>
                    <el-button
                        type="primary"
                        class="mt10"
                        plain
                        @click="SettlementClose('dailySettlementCashier')"
                    >確認結帳</el-button>
                    <el-button
                        type="danger"
                        class="mt10"
                        plain
                        @click="SettlementMgr('cancel')"
                    >中止結帳作業</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Step from "@/components/Step.vue";
import { API } from "@/assets/config";

export default {
    name: "daily_cashier",
    components: { Step },
    data() {
        return {
            recordToEdit: {
                statistic: {},
                creatorList: {},
                voucherStatistic: {},
                cashOnHand: "",
                bankList: [
                    {
                        bankName: ""
                    }
                ],
                bankStatistic: {}
            },
            workflow: [],
            // 傳票日期
            settleDate: ""
        };
    },
    created() {
        // 出納
        this.getCashier();
    },
    methods: {
        SettlementMgr(action) {
            var url = API.dailySettlementMgr + `?action=${action}`;
            const form = new FormData();

            let thenCB = json => {
                this.showAjaxSuccessMsg();
            };
            this.mAxiosPost(url, form, thenCB);
        },

        getCashier() {
            // 取得當日出納關帳資訊
            const url = API.dailySettlementCashier;
            const thenCB = json => {
                if (json.resultData.status == 1) {
                    // 代表未關帳
                    this.$router.push({
                        name: "daily"
                    });
                }
                this.recordToEdit = Object.assign(
                    {},
                    this.recordToEdit,
                    json.resultData
                );
                // 活存餘額 賦值
                this.recordToEdit.bankList.forEach(item => {
                    this.$set(
                        item,
                        "ddAccountBalance",
                        this.recordToEdit.bankTransaction[item.id].balance
                    );
                });
                this.workflow = json.resultData.workflow.filter(item => {
                    // 傳票確認 沒有 status 剛好拿來過濾
                    return item.status >= 0;
                });
                // 傳票日期
                this.settleDate = json.resultData.dailySettlement.settleDate.split(
                    " "
                )[0];
            };
            const thenCatch = error => {
                const errorCode = (error && error.response && error.response.data)
                    ? error.response.data.ErrorCode
                    : null;
                // 當 errorMessage 顯示 系統資料錯誤 就導回 daily
                if (errorCode === "ES0013") {
                    this.$router.push({
                        name: "daily"
                    });
                } else {
                    this.getErrorHandler(error);
                }
            };
            this.mAxiosGet(url, thenCB, {}, false, thenCatch);
        },

        SettlementClose(api) {
            try {
                this.checkAmount();
            } catch (error) {
                this.$message.error(error.message);
                return;
            }

            var url = API[api];
            const form = new FormData();

            // 出納作業
            form.append(
                "cashOnHand",
                this.$removeComma(this.recordToEdit.cashOnHand)
            );
            this.recordToEdit.bankList.forEach(item => {
                item.ddAccountBalance = this.$removeComma(
                    item.ddAccountBalance
                );
            });
            form.append(
                "bankBalance",
                JSON.stringify(this.recordToEdit.bankList)
            );
            let thenCB = json => {
                this.showAjaxSuccessMsg();
                this.getCashier();
            };
            this.mAxiosPost(url, form, thenCB);
        },
        checkAmount() {
            if (
                !this.recordToEdit.cashOnHand &&
                this.recordToEdit.cashOnHand !== 0
            ) {
                throw new Error("請填寫 庫存現金 餘額");
            }
            this.recordToEdit.bankList.forEach(item => {
                if (!item.ddAccountBalance && item.ddAccountBalance !== 0) {
                    throw new Error(`請填寫 ${item.bankName} 活存餘額`);
                }
            });
        },
        resetInput(amount, key) {
            return (this.recordToEdit[key] = this.$addcomma(
                this.$removeComma(amount)
            ));
        },
        resetBankInput(amount, idx) {
            return (this.recordToEdit.bankList[
                idx
            ].ddAccountBalance = this.$addcomma(this.$removeComma(amount)));
        }
    }
};
</script>
<style lang="scss" scoped>
.block-content {
    line-height: 34px;

    p {
        margin-bottom: 4px;
    }

    .sub_title {
        margin-bottom: 0px;
        font-weight: bold;
    }

    table {
        width: 200px;
        display: inline-table;
        margin-right: 10px;

        td {
            padding: 4px 10px;
            text-align: center;
        }
    }

    .box-card {
        margin-top: 10px;
    }
}

.step {
    cursor: pointer;
}
</style>